// ============================================================
// VCS.Nav — Screen-Verwaltung & Tab-Navigation
// ============================================================
window.VCS = window.VCS || {};

VCS.Nav = class {

    // ── Konstanten ───────────────────────────────────────────

    static DESKTOP_BREAKPOINT = 993;

    // ── Konstruktor ──────────────────────────────────────────

    constructor() {
        // View-Cache — Screens
        this._view = {
            preJoinScreen:    $('#preJoinScreen'),
            waitingScreen:    $('#waitingScreen'),
            callScreen:       $('#callScreen'),
            appShell:         $('#appShell'),
            datingScreen:     $('#datingScreen'),
            chatDetailScreen: $('#chatDetailScreen'),
            chatEmptyState:   $('#chatEmptyState'),
            bottomNavItems:   $('#bottomNav .bottom-nav-item'),
            previewVideo:     $('#previewVideo'),
        };
    }

    // ── Screen-Verwaltung ────────────────────────────────────

    // Blendet alle Haupt-Screens aus und zeigt nur den angegebenen
    showScreen(id) {
        this._view.preJoinScreen.addClass('hidden');
        this._view.waitingScreen.addClass('hidden');
        this._view.callScreen.addClass('hidden');
        this._view.appShell.addClass('hidden');
        this._view.datingScreen.addClass('hidden');

        $(`#${id}`).removeClass('hidden');

        // ChatDetail innerhalb appShell auch verstecken wenn appShell gewechselt wird
        if (id === 'appShell') {
            this._view.chatDetailScreen.addClass('hidden');
        }
    }

    showAppShell(tabId) {
        this.showScreen('appShell');
        if (tabId) {
            this.switchTab(tabId);
        }
        if (this.isDesktopLayout() && !VCS.state.chatActiveChatId) {
            this.desktopShowEmptyState();
        }
    }

    // Dating-Unterseite anzeigen. Mobile: Vollbild wie andere Screens. Desktop:
    // die Startseite bleibt als linke Menue-Spalte (#tabDating) stehen und
    // #datingScreen legt sich als rechte Pane ueber das Chat-Detail -- deshalb
    // wird #appShell hier NICHT versteckt (das waere bei showScreen der Fall).
    // switchTab() wird bewusst umgangen: das wuerde onTabShow() ausloesen und die
    // gerade gesetzte View gleich wieder auf die Startseite zuruecksetzen.
    showDatingScreen() {
        if (!this.isDesktopLayout()) {
            this.showScreen('datingScreen');
            return;
        }
        this._view.appShell.removeClass('hidden');
        $('#appShell > .app-tab').addClass('hidden');
        $('#tabDating').removeClass('hidden');
        VCS.state.activeTabId = 'tabDating';
        this._view.bottomNavItems.each(function() {
            $(this).toggleClass('bottom-nav-item--active', $(this).data('tab') === 'tabDating');
        });
        // Chat-Detail rechts ausblenden -- die Dating-Pane deckt es ab.
        this._view.chatDetailScreen.addClass('hidden');
        this._view.datingScreen.removeClass('hidden');
    }

    showHomeScreen() {
        if (VCS.state.chatRegistered) {
            this.showAppShell('tabChats');
            if (VCS.state.chatMyPhone) {
                VCS.e2e?.handleKeySetup?.(VCS.state.chatMyPhone, '').catch(() => {});
            }
        } else {
            this.showScreen('preJoinScreen');
        }
    }

    // ── Tab-Navigation ───────────────────────────────────────

    switchTab(tabId) {
        const prevTab = VCS.state.activeTabId;
        VCS.state.activeTabId = tabId;

        VCS.chat?.closeEmojiPicker?.();
        // Emoji-UI gehoert zu ChatMessages; bei Tab-Wechsel Popup + Seitenleiste
        // schliessen (die Seitenleiste ist eine Layout-Spalte und darf nicht
        // im falschen Tab stehen bleiben).
        VCS.chatMessages?.closeEmojiPicker?.();
        VCS.chatMessages?.closeEmojiSidebar?.();

        if (this.isDesktopLayout()) {
            // Desktop: linkes Panel umschalten, Chat-Detail rechts sichtbar
            $('#appShell > .app-tab').addClass('hidden');
            $(`#${tabId}`).removeClass('hidden');

            if (VCS.state.chatActiveChatId) {
                this._view.chatDetailScreen.removeClass('hidden');
                this.desktopHideEmptyState();
            } else {
                this.desktopShowEmptyState();
            }
        } else {
            // Mobile: Original-Verhalten
            VCS.state.chatActiveChatId   = null;
            VCS.signaling?.sendActiveChat?.();
            VCS.state.chatEditingMessageId = null;
            VCS.chat?.clearReply?.();
            $('#appShell > .app-tab').addClass('hidden');
            this._view.chatDetailScreen.addClass('hidden');
            $(`#${tabId}`).removeClass('hidden');
        }

        // Bottom Nav aktiv-Zustand
        this._view.bottomNavItems.each(function() {
            $(this).toggleClass('bottom-nav-item--active', $(this).data('tab') === tabId);
        });

        // Dating-Pane (Desktop) schliessen, wenn woanders hin gewechselt wird.
        // Auf Mobile ist #datingScreen bei einem Tab-Wechsel ohnehin schon zu.
        // onLeave() gibt die Blob-URLs/rAF-Schleifen der offenen View frei.
        if (tabId !== 'tabDating' && !this._view.datingScreen.hasClass('hidden')) {
            this._view.datingScreen.addClass('hidden');
            VCS.dating?.onLeave?.();
        }

        // Tab-spezifische Aktionen
        if (tabId === 'tabChats'    && VCS.state.chatRegistered) { VCS.chatSetup?.loadChats?.(); }
        if (tabId === 'tabContacts' && VCS.state.chatRegistered) {
            // Immer auf Kontakte-Sub-Tab zurücksetzen
            VCS.state.chatContactsSubTab = 'contacts';
            VCS.chatGroups?.switchSubTab?.('contacts');
            VCS.chatContacts?.loadContacts?.();
        }
        if (tabId === 'tabSettings') { VCS.chatSetup?.updateSettingsUI?.(); }
        if (tabId === 'tabCall' && VCS.state.chatRegistered) { VCS.callHistory?.loadHistory?.(); }
        // Dating: die Startseite ist der Tab, die Unterseiten sind ein eigener
        // Screen. Der Wechsel hierher muss eine offene Unterseite aufraeumen.
        if (tabId === 'tabDating') { VCS.dating?.onTabShow?.(); }
    }

    // ── Desktop Layout ───────────────────────────────────────

    isDesktopLayout() {
        return window.innerWidth >= VCS.Nav.DESKTOP_BREAKPOINT;
    }

    isChatListVisible() {
        if (this._view.appShell.hasClass('hidden')) {
            return false;
        }
        if (this.isDesktopLayout()) {
            return VCS.state.activeTabId === 'tabChats';
        }
        return !$('#tabChats').hasClass('hidden');
    }

    desktopShowEmptyState() {
        this._view.chatDetailScreen
            .removeClass('hidden')
            .addClass('desktop-empty');
        this._view.chatEmptyState.removeClass('hidden');
        // Kein Chat offen -> Emoji-Seitenleiste schliessen (haengt an #appShell,
        // nicht am Chat-Detail, wuerde sonst neben dem Leerzustand stehen bleiben).
        VCS.chatMessages?.closeEmojiSidebar?.();
    }

    desktopHideEmptyState() {
        this._view.chatDetailScreen.removeClass('desktop-empty');
        this._view.chatEmptyState.addClass('hidden');
    }

    // ── Preview-Media ────────────────────────────────────────

    pausePreviewMedia() {
        // Tracks stoppen → Kamera-LED geht aus
        VCS.audioMonitor?.stopPreview?.();
        VCS.blur?.stopPipeline?.();
        if (VCS.state.baseStream) {
            VCS.state.baseStream.getTracks().forEach(t => t.stop());
            VCS.state.baseStream = null;
        }
        VCS.state.localStream = null;
        this._view.previewVideo.prop('srcObject', null);
    }

    resumePreviewMedia() {
        VCS.media?.initPreview?.();
    }

    // ── History / Android Back Button ───────────────────────

    _handleBackNavigation() {
        // 00. Chat-Videoplayer im Pseudo-Vollbild (iPhone-Safari kennt kein
        //     Element-Vollbild)? Deckt mit z-index 10100 alles ab und muss
        //     deshalb noch vor dem PDF-Viewer dran. Echtes Element-Vollbild
        //     beendet der Browser selbst, das taucht hier nie auf.
        if (document.querySelector('.chat-video-player-wrap.chat-vp--fs-fallback')) {
            VCS.chatVideo?.exitFullscreenFallback?.();
            history.pushState({ vcs: true }, '');
            return;
        }

        // 0. PDF-Viewer offen? Liegt ueber allem anderen (z-index 1200) und
        //    muss deshalb zuerst dran. Ueber closePdfViewer(), nicht per
        //    remove(): dort haengen Key-Listener und das pdf.js-Dokument.
        if (document.querySelector('.pdf-viewer-overlay')) {
            VCS.chatMedia?.closePdfViewer?.();
            history.pushState({ vcs: true }, '');
            return;
        }

        // 0b. Medien-Viewer (Bild/Video/Audio aus der Galerie) offen?
        //     Liegt ueber der Galerie und muss deshalb vor ihr geprueft
        //     werden — sonst schliesst Zurueck die Galerie darunter, waehrend
        //     der Viewer offen bleibt. closeViewer() stoppt auch den Player.
        if (document.querySelector('.media-viewer-overlay')) {
            VCS.chatMediaGallery?.closeViewer?.();
            history.pushState({ vcs: true }, '');
            return;
        }

        // 1. Lightbox offen?
        const lightbox = document.querySelector('.media-lightbox');
        if (lightbox) {
            lightbox.remove();
            history.pushState({ vcs: true }, '');
            return;
        }

        // 2. Media-Preview-Overlay offen?
        const mediaPreview = $('#mediaPreviewOverlay')[0];
        if (mediaPreview && !mediaPreview.classList.contains('hidden')) {
            mediaPreview.classList.add('hidden');
            history.pushState({ vcs: true }, '');
            return;
        }

        // 3. Media-Gallery-Overlay offen?
        const gallery = $('#mediaGalleryOverlay')[0];
        if (gallery && !gallery.classList.contains('hidden')) {
            gallery.classList.add('hidden');
            history.pushState({ vcs: true }, '');
            return;
        }

        // 4. Profile-Overlay offen?
        const profile = $('#profileOverlay')[0];
        if (profile && !profile.classList.contains('hidden')) {
            profile.classList.add('hidden');
            history.pushState({ vcs: true }, '');
            return;
        }

        // 5. Device-Settings-Overlay offen?
        const devices = $('#deviceSettingsOverlay')[0];
        if (devices && !devices.classList.contains('hidden')) {
            devices.classList.add('hidden');
            history.pushState({ vcs: true }, '');
            return;
        }

        // 6. Dating-Unterseite offen? Muss vor Chat-Detail und Tab-Wechsel
        //    geprueft werden: #datingScreen liegt neben #appShell, die beiden
        //    Faelle unten wuerden sonst im verdeckten appShell herumschalten,
        //    waehrend Dating offen stehen bleibt. handleBack() fuehrt zurueck
        //    auf den Startseiten-Tab.
        //    Steht nur der Tab offen, ist #datingScreen versteckt und der
        //    normale Tab-Pfad unten greift -- richtig so, ein Tab ist kein
        //    Sonderfall.
        if (!this._view.datingScreen.hasClass('hidden')) {
            VCS.dating?.handleBack?.();
            history.pushState({ vcs: true }, '');
            return;
        }

        // 7. Chat-Detail offen (Mobile)?
        if (VCS.state.chatActiveChatId
                && !this._view.chatDetailScreen.hasClass('hidden')
                && !this.isDesktopLayout()) {
            $('#chatDetailBack').trigger('click');
            history.pushState({ vcs: true }, '');
            return;
        }

        // 8. Anderer Tab als Chats?
        if (VCS.state.activeTabId && VCS.state.activeTabId !== 'tabChats'
                && !this._view.appShell.hasClass('hidden')) {
            this.switchTab('tabChats');
            history.pushState({ vcs: true }, '');
            return;
        }

        // 9. Bereits auf Hauptseite → nichts tun, normales Browser-Verhalten
    }

    // ── Init ─────────────────────────────────────────────────

    init() {
        // Bottom Nav — Klicks
        this._view.bottomNavItems.on('click', async function() {
            const tabId = $(this).data('tab');
            if (!tabId) {
                return;
            }
            // Ungespeicherte Dating-Profil-Aenderungen? Erst fragen, bevor der Tab
            // wechselt -- switchTab() schaltet den Screen sofort weg, ein Guard
            // danach kaeme zu spaet. Nur explizites false (bleiben) blockiert.
            if (VCS.dating?.isProfileDirty?.()
                    && (await VCS.datingProfile?.confirmLeave?.()) === false) {
                return;
            }
            VCS.nav.switchTab(tabId);
        });

        // Android Back Button / Browser-Zurück
        history.pushState({ vcs: true }, '');
        window.addEventListener('popstate', () => {
            this._handleBackNavigation();
        });

        // Desktop/Mobile Layout-Wechsel bei Resize
        let wasDesktop = this.isDesktopLayout();
        $(window).on('resize', () => {
            const nowDesktop = this.isDesktopLayout();
            if (wasDesktop === nowDesktop) {
                return;
            }
            wasDesktop = nowDesktop;

            // Nur reagieren wenn appShell sichtbar
            if ($('#appShell').hasClass('hidden')) {
                return;
            }

            if (nowDesktop) {
                $(`#${VCS.state.activeTabId}`).removeClass('hidden');
                if (VCS.state.chatActiveChatId) {
                    $('#chatDetailScreen').removeClass('hidden');
                    this.desktopHideEmptyState();
                } else {
                    this.desktopShowEmptyState();
                }
            } else {
                if (VCS.state.chatActiveChatId && !$('#chatDetailScreen').hasClass('hidden')) {
                    $('#appShell > .app-tab').addClass('hidden');
                    this.desktopHideEmptyState();
                } else {
                    $('#chatDetailScreen').addClass('hidden');
                    $(`#${VCS.state.activeTabId}`).removeClass('hidden');
                }
            }
        });
    }
};
